import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

const getAutosuggestHighlightParts = (label, inputValue) => {
  const matches = match(label, inputValue, { insideWords: true });
  const parts = parse(label, matches);
  return parts;
};

export default getAutosuggestHighlightParts;
